import React from 'react';

import {AbilitiesStep} from './abilities/abilities-step';
import {ClassStep} from './class-step';
import {EquipmentStep} from './equipment/equipment-step';
import {OriginStep} from './origin-step';
import {SpecieStep} from './specie-step';
import type {MasterStep} from './use-step-summaries';

const STEP_COMPONENTS: Record<MasterStep, React.FC> = {
	class: ClassStep,
	origin: OriginStep,
	specie: SpecieStep,
	abilities: AbilitiesStep,
	equipment: EquipmentStep,
};

export const StepContent: React.FC<{step: MasterStep}> = ({step}) => {
	const Step = STEP_COMPONENTS[step];
	return <Step />;
};
